import BaseAPI from '../base';

function importMenu(cafe_id) {
  return BaseAPI.post(`resico/import-menu/${cafe_id}`);
}

function getProducts(cafe_id) {
  return BaseAPI.get(`resico/products/${cafe_id}`);
}

function connect(cafe_id, client_key, client_code) {
  return BaseAPI.post(`resico/connect/${cafe_id}`, { client_key, client_code });
}

export default {
  importMenu,
  getProducts,
  connect,
};
